import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.scss']
})
export class ResetPasswordFormComponent implements OnInit {
  token=""
  email=""
  constructor(public auth:AuthService,public router:Router,public common:CommonService,public messageService:MessageService,public activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      //console.log(params)
      if(params['token']){
        this.token=params['token']
        this.email=params['email']
        //console.log(this.email)
        //console.log(this.token)
      }

    });
  }

  resetPassword(resetForm){

    if(this.token){
      this.common.showLoader()
      resetForm.value.token=this.token
      this.auth.resetPasswordWithToken(resetForm.value).subscribe((res : any)=>{
        
        if(res.result){
          this.router.navigateByUrl("/signin")
          this.messageService.add({severity:'success', summary:'Successful', detail:"Password reset successful, please login to continue"});
          
          this.common.stopLoader()
        }
        else{
          this.messageService.add({severity:'error', summary:'Some Error occured', detail:res.message});
      this.common.stopLoader()
        }
        
      },err=>{
        //console.log(err)
      this.messageService.add({severity:'error', summary:'Some Error occured', detail:""});
      this.common.stopLoader()
      })
    }else{
      this.messageService.add({severity:'error', summary:'Session Expired', detail:""});
    }
    
  }

  showPassword(e){
    if(e.target.previousSibling.getAttribute('type') == 'password'){
      e.target.previousSibling.setAttribute('type','text')
      e.target.classList.replace('fa-eye', 'fa-eye-slash')
    }
    else{
      
      e.target.previousSibling.setAttribute('type','password')
      e.target.classList.replace('fa-eye-slash', 'fa-eye')
    }
  }

}
